// marker-icons.js
import L from 'leaflet'

export const red = new L.icon({
  iconUrl: require('./red.png'),
  iconAnchor: [3, 3],
  iconSize: [6, 6],
})

export const green_spot = new L.icon({
  iconUrl: require('./green_spot.png'),
  iconAnchor: [35, 50],
  labelAnchor: [-6, 0],
  popupAnchor: [0, -15],
  iconSize: [70, 70],
})

export const blue_spot = new L.icon({
  iconUrl: require('./blue_spot.png'),
  iconAnchor: [35, 50],
  labelAnchor: [-6, 0],
  popupAnchor: [0, -15],
  iconSize: [70, 70],
})
